//@flow

import {saveStoreStockSettingsApi, getStoreStockSettingsApi} from '../api';

import type {
  StoreStockSettings,
  StoreStockSettingsRequest,
} from '../../../../entities';

export async function saveStoreStockSettingsService(
  storeStockSettings: StoreStockSettingsRequest
): Promise<StoreStockSettings> {
  return saveStoreStockSettingsApi(storeStockSettings).toPromise();
}

export async function getStoreStockSettingsService(): Promise<StoreStockSettings> {
  return getStoreStockSettingsApi().toPromise();
}
